import { render, staticRenderFns } from "./VideoDescription.vue?vue&type=template&id=a994ad7c&scoped=true&"
import script from "./VideoDescription.vue?vue&type=script&lang=js&"
export * from "./VideoDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a994ad7c",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/elements/VideoDescription.vue
// module id = null
// module chunks = 